import { render } from "./DeclencheurQuitSite.vue?vue&type=template&id=1eaa459e"
import script from "./DeclencheurQuitSite.vue?vue&type=script&lang=ts"
export * from "./DeclencheurQuitSite.vue?vue&type=script&lang=ts"
script.render = render

export default script